export default __webpack_public_path__ + "static/media/quill1.8c1057eb.svg";